program Boletos;

uses
  Vcl.Forms,
  WEBLib.Forms,
  Principal in 'Principal.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TFormPrincipal, FormPrincipal);
  Application.Run;
end.
